import defaultMenu from './menu.json';
import type { MenuConfig } from './types';
import { normalizeLegacyPath, resolveLabel } from './utils';

interface RouteEntry {
  mode: string;
  qs?: string;
  name: string;
}

const extractRoutes = (items: MenuConfig[], routes: Map<string, RouteEntry> = new Map()): Map<string, RouteEntry> => {
  for (const item of items) {
    if ('Type' in item && item.Type === 'legacy' && item.LegacyUrl && item.LegacyMode) {
      const path = normalizeLegacyPath(item.LegacyUrl);
      routes.set(path, {
        mode: item.LegacyMode,
        qs: item.LegacyQs || undefined,
        name: resolveLabel(item.Label)
      });
    }
    if (item.Children) {
      extractRoutes(item.Children, routes);
    }
  }
  return routes;
};

export const legacyRouteMap = extractRoutes(defaultMenu.Items as MenuConfig[]);

export const findRouteEntry = (pathname: string): RouteEntry | undefined => {
  return legacyRouteMap.get(pathname);
};
